import UserList from '@/pages/outlet-app/user/routes'

export default {
  path: 'outlet-app',
  component: () => import('@/components/layouts/ChildLayout.vue'),
  children: [...UserList]
}
